import { render, staticRenderFns } from "./PopUpImages.vue?vue&type=template&id=4c97889a&"
import script from "./PopUpImages.vue?vue&type=script&lang=js&"
export * from "./PopUpImages.vue?vue&type=script&lang=js&"
import style0 from "./PopUpImages.vue?vue&type=style&index=0&id=4c97889a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports